/** Horizontal plan measurements, not distances/angles on the sloping roof. */
export function outlineMeasurements(ring) {
  if (!Array.isArray(ring) || ring.length < 3 || ring.some((p) => !Number.isFinite(p?.x) || !Number.isFinite(p?.y))) return [];
  const area2 = ring.reduce((sum, p, i) => {
    const q = ring[(i + 1) % ring.length];
    return sum + p.x * q.y - q.x * p.y;
  }, 0);
  const winding = area2 < 0 ? -1 : 1;
  return ring.map((p, i) => {
    const prev = ring[(i + ring.length - 1) % ring.length], next = ring[(i + 1) % ring.length];
    const ux = p.x - prev.x, uy = p.y - prev.y, vx = next.x - p.x, vy = next.y - p.y;
    const before = Math.hypot(ux, uy), length = Math.hypot(vx, vy);
    const turn = Math.atan2(ux * vy - uy * vx, ux * vx + uy * vy) * winding;
    const angle = before > 1e-9 && length > 1e-9 && Math.abs(area2) > 1e-9
      ? (Math.PI - turn) * 180 / Math.PI : null;
    const outward = length > 1e-9 ? { x: winding * vy / length, y: -winding * vx / length } : { x: 0, y: -1 };
    let bx = before > 1e-9 ? -ux / before : 0, by = before > 1e-9 ? -uy / before : 0;
    if (length > 1e-9) { bx += vx / length; by += vy / length; }
    if (angle > 180) { bx = -bx; by = -by; }
    const bisectorLength = Math.hypot(bx, by);
    const inward = bisectorLength > 1e-9 ? { x: bx / bisectorLength, y: by / bisectorLength }
      : { x: -outward.x, y: -outward.y };
    return { length, angle, midpoint: { x: (p.x + next.x) / 2, y: (p.y + next.y) / 2 }, outward, inward };
  });
}
